export default __webpack_public_path__ + "static/media/rgb.84da9818.png";